module.exports = __webpack_public_path__ + "img/makerspace.d4a06160.png";